import { render, staticRenderFns } from "./Treatments_Correlations.vue?vue&type=template&id=f1c76062"
import script from "./Treatments_Correlations.vue?vue&type=script&lang=js"
export * from "./Treatments_Correlations.vue?vue&type=script&lang=js"
import style0 from "./Treatments_Correlations.vue?vue&type=style&index=0&id=f1c76062&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports